import Splide from '@splidejs/splide';

export default function initClientLogos() {
  const slider = document.querySelector('.js-client-logos');

  if (!slider) return;

  new Splide(slider, {
    type: 'loop',
    perPage: 5,
    perMove: 1,
    gap: 'clamp(34px, 5vw, 82px)',
    arrows: true,
    pagination: false,
    autoplay: true,
    interval: 2600,
    speed: 850,
    pauseOnHover: true,
    pauseOnFocus: true,
    breakpoints: {
      1100: {
        perPage: 4,
      },
      767: {
        perPage: 3,
        gap: '28px',
      },
      520: {
        perPage: 2,
        gap: '20px',
      },
    },
  }).mount();
}
